import { LocalContentProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  LocalContentProps["options"],
  OptionalPropertyOf<LocalContentProps["options"]>
> = {
  mapProvider: {
    name: "maptiler",
  },
  zoom: 14,
  pitch: 0,
  bearing: 0,
  cooperativeGestures: true,
  distanceUnit: "metric",
  hideScores: false,
  scoresMenu: {
    defaultOpen: true,
    title: true,
    categories: {
      amenities: {
        hide: false,
        order: 1,
        colors: {
          background: "#FFF2C3",
          fill: "#BF8500",
        },
        scores: {
          shopping: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          groceries: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          restaurants: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          cafes: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      education: {
        hide: false,
        order: 2,
        colors: {
          background: "#E4EFFF",
          fill: "#003548",
        },
        scores: {
          daycares: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          primary_schools: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          high_schools: {
            hide: false,
            hideScore: false,
            order: 3,
          },
        },
      },
      transport: {
        hide: false,
        order: 3,
        colors: {
          background: "#E9F8FA",
          fill: "#008491",
        },
        scores: {
          transit_friendly: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          car_friendly: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          pedestrian_friendly: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          cycling_friendly: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      character: {
        hide: false,
        order: 4,
        colors: {
          background: "#FFDAAC",
          fill: "#FF7044",
        },
        scores: {
          nightlife: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          vibrant: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          historic: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          quiet: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      nature: {
        hide: false,
        order: 5,
        colors: {
          background: "#D8F4D9",
          fill: "#0F766E",
        },
        scores: {
          parks: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          greenery: {
            hide: false,
            hideScore: false,
            order: 2,
          },
        },
      },
      health: {
        hide: false,
        order: 6,
        colors: {
          background: "#FFE7FE",
          fill: "#FF84D6",
        },
        scores: {
          wellness: {
            hide: false,
            hideScore: false,
            order: 1,
          },
        },
      },
    },
  },
};

export default defaultState;
